export default function ErrorManagement({ errorObj }) {
    return (
        !!errorObj && (
            <span className='flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1'>
                {errorObj.message}
            </span>
        )
    );
}

export const addErrorToClass = (isError) =>
    isError && `border-red-700`;
